var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 23.5L5.33116 22.6515C4.86253 23.1201 4.86253 23.8799 5.33116 24.3485L6.17969 23.5ZM22.513 24.7C23.1758 24.7 23.713 24.1627 23.713 23.5C23.713 22.8373 23.1758 22.3 22.513 22.3V24.7ZM12.3312 31.3485C12.7998 31.8172 13.5596 31.8172 14.0282 31.3485C14.4968 30.8799 14.4968 30.1201 14.0282 29.6515L12.3312 31.3485ZM14.0282 17.3485C14.4968 16.8799 14.4968 16.1201 14.0282 15.6515C13.5596 15.1828 12.7998 15.1828 12.3312 15.6515L14.0282 17.3485ZM6.17969 24.7H22.513V22.3H6.17969V24.7ZM5.33116 24.3485L12.3312 31.3485L14.0282 29.6515L7.02822 22.6515L5.33116 24.3485ZM7.02822 24.3485L14.0282 17.3485L12.3312 15.6515L5.33116 22.6515L7.02822 24.3485Z",
    fill: "#1B1625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlack);
export default __webpack_public_path__ + "static/media/left_arrow_black.5ca1c449f5fce82cf44f9997b2d609a7.svg";
export { ForwardRef as ReactComponent };